import './lib/AnimationEasing';

import './component/AnalyticsSetup';
import "./component/AnalyticsFormValidation";

// Animations
import SiteAnimations from './component/SiteAnimation';
SiteAnimations.createInstance([
	{
		observedSelector: '.richContent__animationWrap',
		options: {
			rootMargin: '0px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.pageFooter__copyright',
		options: {
			rootMargin: '0px 0px',
			threshold: 0
		}
	},
]);

// Only the collapsableGroup items
import CollapsableGroup from './component/CollapsableGroup/CollapsableGroup';
new CollapsableGroup();

// Only the questionAnswer navigation
import QuestionAnswer from './component/QuestionAnswer/QuestionAnswer';
new QuestionAnswer();

// ListItemGroup Carousel [Generated] - updated for homepage redesign
import './component/ListItemGroup/horizontalScoller';

// Testimonial Carousel
import testimonialCarousel from './component/TestimonialCarousel/TestimonialCarousel';
testimonialCarousel('.testimonial__itemsCarousel');

// History Timeline Carousel
import timeline from './component/Timeline/Timeline';
timeline('.timeline__items');

// Image Carousel
import imageCarousel from './component/ImageCarousel/ImageCarousel';
imageCarousel('.imageCarousel__inner');

import initComparisonTableLogic from '../blocks/ComparisonTable/ComparisonTable';
initComparisonTableLogic();

/* ? */
import initInternetSpeedQuizLogic from '../blocks/InternetSpeedQuiz/InternetSpeedQuiz';
initInternetSpeedQuizLogic();

import Gallery from './component/Gallery/Gallery';
new Gallery();

import allHail from './component/hfil';
allHail();

import instrumentCheckpoint from "./component/CheckpointInstrumentation";
instrumentCheckpoint();

import Orphans from './component/orphanage';
let orphan = [];
orphan.push('.callToAction__heading');
orphan.push('.callToAction__content p');
orphan.push('.masthead__content p');
orphan.push('[class*="intro"] p');
Orphans.adopt(orphan.join());

// checkpoint frontend overrides for address lookup form
import './component/checkpointOverrides';

import "./component/markTransformedPhoneNumbers";


// Masthead Carousel
//
import mastheadCarousel from './component/MastheadCarousel/MastheadCarousel';
mastheadCarousel('.mastheadCarousel__items');
